// Dedicated-page configs: Huisdieren, Events, Magic Mirror, Audio Gastenboek,
// Vrij Werk (art prints), Studio, Studio Special

export const HUISDIEREN = {
  hero: "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/0rpfhm02_IMG_3001%20%281%29.webp",
  intro:
    "Professionele fotoshoots voor honden, katten en paarden — altijd samen met baasje(s). Op locatie in de buitenlucht. Vol liefde, geduld en oog voor karakter.",
  highlights: ["Professioneel & ervaren", "Geduldig & diervriendelijk", "Op buitenlocatie", "Altijd samen met baasje(s)"],
  images: [
    "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/igwa0eln_IMG_2605.webp",
    "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/0rpfhm02_IMG_3001%20%281%29.webp",
    "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/t4193qjk_IMG_1902.webp",
  ],
  packages: [
    { name: "Basis", price: "€145", features: ["1 uur fotoshoot", "Altijd samen met baas(je(s))", "Op buitenlocatie", "minimum 5 professioneel bewerkte foto's", "Online galerij"] },
    { name: "Comfort", price: "€195", features: ["1,5 uur fotoshoot", "Altijd samen met baas(je(s))", "Op buitenlocatie", "minimum 10 professioneel bewerkte foto's", "Online galerij"], featured: true },
    { name: "Deluxe", price: "€245", features: ["2 uur fotoshoot", "Altijd samen met baas(je(s))", "Meerdere locaties mogelijk", "minimum 15 professioneel bewerkte foto's", "Online galerij"] },
  ],
  note: "Voor honden, katten én paarden. Meerdere dieren? Vraag gerust naar de mogelijkheden.",
  extras: [
    { name: "Extra foto (bewerkt)", price: "€15/stuk" },
    { name: "Luxe fotoboek (30x30 cm)", price: "€95" },
    { name: "Fine art print", price: "vanaf €35" },
    { name: "Wanddecoratie (canvas, dibond, plexi)", price: "vanaf €45" },
    { name: "Digitale bestanden (alle onbewerkte foto's)", price: "€75" },
    { name: "Snelle oplevering (binnen 5 werkdagen)", price: "€25" },
  ],
};

export const EVENTS = {
  hero: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?auto=format&fit=crop&w=2000&q=80",
  intro:
    "Van kleine feesten tot grote gala's, van verjaardagen tot bedrijfsevents. Ik leg de sfeer vast: speeches, lach, dansvloer. Combineer met de Magic Mirror en het Audio Gastenboek voor een écht onvergetelijke beleving.",
  highlights: ["Snelle reactie binnen 24 uur", "Persoonlijke aanpak op maat van je event", "Zorgeloos genieten — wij regelen de rest", "Combineerbaar met Magic Mirror & Audio"],
  packages: [
    { name: "Basis", price: "€275", features: ["2 uur fotografie", "Professioneel bewerkte foto's", "Online galerij", "Groepsfoto's & sfeerfoto's"] },
    { name: "Comfort", price: "€425", features: ["4 uur fotografie", "Professioneel bewerkte foto's", "Online galerij", "Groepsfoto's & sfeerfoto's"], featured: true },
    { name: "Luxe", price: "€625", features: ["Volledige dag (tot 8 uur)", "Professioneel bewerkte foto's", "Online galerij", "Groepsfoto's & sfeerfoto's"] },
  ],
  extraOpties: [
    { name: "Extra uren fotografie", price: "vanaf €75/u" },
    { name: "Luxe album (30x30 cm)", price: "€150" },
    { name: "Foto op canvas", price: "vanaf €45" },
    { name: "Extra prints", price: "vanaf €1,50/stuk" },
  ],
  combos: ["party-combo", "premium-party-combo"],
};

export const MAGIC_MIRROR = {
  hero: "https://customer-assets-eiarnc6j.emergentagent.net/job_capture-memories-11/artifacts/z4dhrm4m_da142cf9-af41-4e2e-be99-1fc6d98162c1.__CR0%2C0%2C1464%2C600_PT0_SX1464_V1___.jpg",
  intro:
    "Maak van jouw feest een herinnering voor altijd. De perfecte mix van fun, beleving en onvergetelijke herinneringen voor jong & oud.",
  manifesto:
    "Vergeet die voorspelbare en saaie photobooth. Magic Mirror is verrassend, uniek en fun!",
  usps: [
    { icon: "Sparkles", title: "Een uniek product", text: "Nieuw concept — iets wat jouw gasten nog nooit hebben gezien." },
    { icon: "PartyPopper", title: "Fun gegarandeerd", text: "Top entertainment voor jong en oud, van begin tot einde." },
    { icon: "Wand2", title: "Magische beleving", text: "Het lijkt op een echte spiegel — maar het is een touchscreen." },
    { icon: "Smile", title: "Gebruiksvriendelijk", text: "Zeer gebruiksvriendelijk en gemakkelijk te bedienen." },
    { icon: "Printer", title: "Signeer & print", text: "Looking good? Signeer, print en neem je foto direct mee." },
    { icon: "Share2", title: "Deel op social media", text: "Direct delen via Facebook, Instagram of via QR." },
  ],
  customization: {
    eyebrow: "Volledig op maat",
    title: "Een spiegel die past bij jouw verhaal.",
    text: "De Magic Mirror kan volledig worden gepersonaliseerd zodat de uitstraling perfect aansluit bij jouw merk, evenement, huisstijl of thema. De geprinte foto's én de social-media presets worden vooraf op maat ontworpen — zo krijgt elke gast een aandenken dat aanvoelt alsof het speciaal voor jouw feest is gemaakt.",
    bullets: [
      "Custom design fotostrip in jouw huisstijl",
      "Logo, kleuren en teksten aanpasbaar",
      "Achtergrond op maat van jouw thema",
      "Social share-templates volledig gebrand",
    ],
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_capture-memories-11/artifacts/2oh34rg9_image.png",
  },
  inclusief: [
    "Onbeperkt leuke foto's",
    "Hoge kwaliteit prints (10x15 cm)",
    "Persoonlijk ontwerp fotostrip",
    "Props & accessoires",
    "Online galerij met alle foto's",
    "Op- en afbouw",
    "Professionele begeleiding",
    "Reiskosten inbegrepen (regio Beveren)",
  ],
  priceFrom: "vanaf €395",
  occasions: ["Verjaardagen", "Huwelijken", "Jubilea", "Communies", "Bedrijfsfeesten", "Babyshowers", "En meer"],
  packages: [
    { name: "Basic", price: "€395", features: ["Magic Mirror Fotobooth", "Onbeperkt prints", "Props & accessoires", "Online galerij", "Op- en afbouw"] },
    { name: "Deluxe", price: "€495", features: ["Magic Mirror Fotobooth", "Onbeperkt prints", "Props & accessoires", "Online galerij", "Gepersonaliseerde fotostrip", "Achtergrond naar keuze", "Op- en afbouw"] },
    { name: "Premium", price: "€695", featured: true, badge: "Meest gekozen", features: ["Magic Mirror Fotobooth", "Onbeperkt prints", "Props & accessoires", "Online galerij", "Gepersonaliseerde fotostrip", "Achtergrond naar keuze", "Audio Gastenboek", "Confetti kanonnen (2x)", "Op- en afbouw"] },
  ],
  faq: [
    { q: "Hoeveel plaats heb ik nodig?", a: "Reken op minimaal 2 x 2 meter. Wij zorgen voor de rest." },
    { q: "Werkt de Magic Mirror ook buiten?", a: "Ja, mits een overdekte en stabiele locatie in de buurt van een stopcontact." },
    { q: "Zijn de foto's ook digitaal beschikbaar?", a: "Zeker. Elke gast ontvangt een link naar de galerij." },
    { q: "Kan het design gepersonaliseerd worden?", a: "Absoluut — op maat van jullie thema, kleuren of huisstijl." },
    { q: "Kan ik de Magic Mirror combineren met het Audio Gastenboek?", a: "Ja! Dat is inbegrepen in ons Premium pakket, of los toe te voegen." },
  ],
  combos: ["wedding-combo", "party-combo", "premium-party-combo"],
};

export const AUDIO_GUESTBOOK = {
  hero: "https://images.unsplash.com/photo-1512125098323-cce1035bf4bf?auto=format&fit=crop&w=2000&q=80",
  intro:
    "Een vintage telefoon, een lieve stem in je oor, en het verzoek om iets moois in te spreken. Het Audio Gastenboek van Lenslopers geeft jullie iets wat foto's niet kunnen — de stem van de mensen die er waren.",
  highlights: ["Vintage telefoon in luxe uitvoering", "Volledige avond gebruik", "Professionele audio-editing", "Inclusief mooie USB-stick", "Combineerbaar met Magic Mirror"],
  packages: [
    { name: "Basis", price: "€125", features: ["Vintage telefoon", "Volledige avond", "Professionele audio-editing", "Inclusief mooie USB-stick", "Digitale levering (MP3)"] },
  ],
  combos: ["wedding-combo", "party-combo", "premium-party-combo"],
};

export const VRIJ_WERK_INTRO =
  "Naast opdrachten fotografeer ik ook vrij werk. Beelden waar ik verwondering, stilte en experiment in zoek. Deze werken kunnen als beperkte oplage prints besteld worden — op fine art papier, canvas, dibond of plexi.";

export const PRINT_SIZES = [
  { id: "a4", label: "Fine Art print A4 (21 × 30 cm)", price: "€45" },
  { id: "a3", label: "Fine Art print A3 (30 × 42 cm)", price: "€85" },
  { id: "canvas-40x60", label: "Canvas 40 × 60 cm", price: "€145" },
  { id: "dibond-60x90", label: "Dibond 60 × 90 cm", price: "€245" },
  { id: "plexi-80x120", label: "Plexi 80 × 120 cm", price: "€425" },
];

export const VRIJ_WERK = [
  {
    id: "highland-bull",
    title: "Highland",
    series: "Silent Portraits",
    year: 2026,
    editionOf: 25,
    priceFrom: "vanaf €45",
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_capture-memories-11/artifacts/csrodssu_0B5A0853%20kopie%202.webp",
  },
];

export const STUDIO = {
  hero: "https://images.pexels.com/photos/30332804/pexels-photo-30332804.jpeg?auto=compress&cs=tinysrgb&w=2000",
  intro:
    "Een professionele studio met verschillende decors, professionele belichting en een rustige sfeer. Voor portret, LinkedIn, kinderen, producten en creatieve projecten.",
  services: [
    { title: "Portretten", text: "Persoonlijke of zakelijke portretten met tijdloze belichting." },
    { title: "LinkedIn", text: "Professioneel portret, snel geleverd, klaar voor jouw profiel." },
    { title: "Kinderen", text: "Speels en rustig — kinderen komen op hun gemak in de studio." },
    { title: "Producten", text: "Heldere, verkoopklare productfoto's voor webshop en marketing." },
  ],
};

export const STUDIO_SPECIAL = {
  hero: "https://images.unsplash.com/photo-1618172193763-c511deb635ca?auto=format&fit=crop&w=2000&q=80",
  intro:
    "De studio wordt een portaal. Van klassieke portretten tot magische werelden — kies je decor, wij zorgen voor het licht.",
  collections: [
    {
      key: "classics",
      icon: "Camera",
      title: "Studio Classics",
      accent: "#111111",
      desc: "De tijdloze basis — schoon, professioneel en persoonlijk.",
      items: ["Zakelijke portretten", "Familie", "Koppels", "Zwangerschap", "Baby", "Huisdieren"],
    },
  ],
  greenScreen: {
    eyebrow: "In de studio",
    badge: "Nieuw",
    title: "Green Screen",
    titleAccent: "Fantasy Collection",
    script: "Kies uit tientallen achtergronden en beleef jouw eigen avontuur",
    features: [
      "Magische werelden",
      "Sprookjes & kastelen",
      "Stranden & natuur",
      "Ruimte & fantasie",
      "En nog veel meer!",
    ],
    tiers: [
      {
        label: "Premium",
        count: "2 achtergronden",
        note: "of nog vele andere",
        options: [
          { name: "Winter Wonderland", img: "https://images.unsplash.com/photo-1418985991508-e47386d96a71?auto=format&fit=crop&w=800&q=70" },
          { name: "Kasteel", img: "https://images.unsplash.com/photo-1533154683836-84ea7a0bc310?auto=format&fit=crop&w=800&q=70" },
        ],
      },
      {
        label: "Luxe",
        count: "5 achtergronden",
        note: "of nog vele andere",
        options: [
          { name: "Bloemenveld", img: "https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?auto=format&fit=crop&w=800&q=70" },
          { name: "Jungle Expedition", img: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=800&q=70" },
          { name: "Strand Zonsondergang", img: "https://images.unsplash.com/photo-1506953823976-52e1fdc0149a?auto=format&fit=crop&w=800&q=70" },
          { name: "Ruimte Avontuur", img: "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?auto=format&fit=crop&w=800&q=70" },
          { name: "Fantasy Bos", img: "https://images.unsplash.com/photo-1511497584788-876760111969?auto=format&fit=crop&w=800&q=70" },
        ],
      },
    ],
    pets: "Ook perfect voor huisdieren! Van superheld tot piraat — jouw viervoeter in de hoofdrol.",
    miniShoot: {
      name: "Mini Shoot",
      price: "€75",
      features: ["20 minuten fotoshoot", "minimum 5 digitale foto's", "1 achtergrond naar keuze"],
    },
  },
  seasons: {
    eyebrow: "Collectie",
    title: "Seizoenscollecties",
    intro: "Elk seizoen heeft zijn eigen sfeer, kleur en licht — kies jouw favoriet.",
    items: [
      { label: "Winter", img: "https://images.unsplash.com/photo-1483664852095-d6cc6870702d?auto=format&fit=crop&w=600&q=70" },
      { label: "Valentijn", img: "https://images.unsplash.com/photo-1518199266791-5375a83190b7?auto=format&fit=crop&w=600&q=70" },
      { label: "Pasen", img: "https://images.unsplash.com/photo-1457301353672-324d6d14f471?auto=format&fit=crop&w=600&q=70" },
      { label: "Lente", img: "https://images.unsplash.com/photo-1490750967868-88aa4486c946?auto=format&fit=crop&w=600&q=70" },
      { label: "Zomer", img: "https://images.unsplash.com/photo-1533105079780-92b9be482077?auto=format&fit=crop&w=600&q=70" },
      { label: "Herfst", img: "https://images.unsplash.com/photo-1507371341162-763b5e419408?auto=format&fit=crop&w=600&q=70" },
      { label: "Halloween", img: "https://images.unsplash.com/photo-1509557965875-b88c97052f0e?auto=format&fit=crop&w=600&q=70" },
      { label: "Kerst", img: "https://images.unsplash.com/photo-1543589077-47d81606c1bf?auto=format&fit=crop&w=600&q=70" },
    ],
  },
  extraBackgrounds: {
    title: "Extra opties",
    intro: "Dezelfde opname, meerdere verhalen. Kies bij wat je toevoegt na de shoot:",
    tiers: [
      { label: "1 achtergrond inbegrepen", price: "Inbegrepen" },
      { label: "Extra achtergrond", price: "€12,50" },
      { label: "5 extra achtergronden", price: "€45" },
      { label: "Volledige Fantasy Gallery (alle beelden)", price: "€75" },
      { label: "Luxe fotoboek (15x15 cm)", price: "op aanvraag" },
      { label: "Fine art print / canvas", price: "op aanvraag" },
    ],
  },
  packages: [
    { name: "Studio Basic", price: "€125", features: ["30 minuten fotoshoot", "1 collectie naar keuze", "minimum 5 professioneel bewerkte foto's", "1 achtergrond inbegrepen", "Online galerij"] },
    { name: "Studio Comfort", price: "€175", features: ["45 minuten fotoshoot", "2 collecties naar keuze", "minimum 10 professioneel bewerkte foto's", "2 achtergronden", "Online galerij"] },
    { name: "Studio Deluxe", price: "€245", featured: true, features: ["1 uur fotoshoot", "3 collecties naar keuze", "minimum 15 professioneel bewerkte foto's", "5 achtergronden", "Online galerij"] },
    { name: "Studio Signature", price: "€395", features: ["1,5 uur fotoshoot", "Onbeperkte collecties", "minimum 25 professioneel bewerkte foto's", "Volledige Fantasy Gallery", "Online galerij"] },
  ],
  seasonsPass: {
    name: "Lenslopers Seasons Pass",
    price: "€295 / jaar",
    tagline: "Elk seizoen een verhaal",
    perks: [
      "4 seizoensshoots (winter, lente, zomer, herfst)",
      "Voorrang bij boekingen",
      "10% korting op extra foto's",
      "Korting op de Magic Mirror Fotobooth",
      "Korting op wanddecoratie en albums",
    ],
  },
};
